<template>
  <div class="default-icon">
    <v-icon v-if="!type" :icon="`${icon}`" :size="size"></v-icon>
    <img v-if="type === 'svg'" :src="icon" :width="size" :alt="name" loading="lazy" />
  </div>
</template>

<script setup lang="ts">
import { VIcon } from 'vuetify/components'
defineProps<{
  icon: string,
  type?: string,
  size: string | number
  name?: string
}>();
</script>

<style scoped>
.default-icon,
img {
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  vertical-align: middle;
}
</style>